import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

/**
 * The check box of a selection column (the hunter-grid rules size it). A click
 * or Space toggles it.
 */
@Component({
  selector: 'app-table-checkbox',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `<div
    class="app-checkbox"
    role="checkbox"
    tabindex="0"
    [attr.aria-checked]="checked"
    [attr.aria-label]="ariaLabel"
    (click)="onClick($event)"
    (keydown.space)="onClick($event)"
  >
    <div class="app-checkbox-box" [class.app-highlight]="checked">
      <span
        class="app-checkbox-icon"
                [class.app-checked]="checked"
      ></span>
    </div>
  </div>`,
})
export class TableCheckboxComponent {
  @Input() checked = false;
  @Input() ariaLabel = 'Select';
  @Output() toggled = new EventEmitter<Event>();

  onClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.toggled.emit(event);
  }
}
